import {CustomSelect} from './CustomSelect';
import {NoOptionsMessage} from './components';

export type {Options} from 'chakra-react-select';
export type {Option as ReactSelectOption} from './CustomSelect';
export {components as customSelectComponent} from './CustomSelect';
export {AsyncSelect} from './AsyncSelect';

export * from './SystemSelect';

export * from './AvatarReactSelect';
export * from './ReactSelect';
export * from './schema';
export * from './module-augmentation';
export * from './types';

type CompoundCustomSelect = typeof CustomSelect & {
  NoOptionsMessage: typeof NoOptionsMessage;
};

const CompoundCustomSelect = CustomSelect as unknown as CompoundCustomSelect;

CompoundCustomSelect.NoOptionsMessage = NoOptionsMessage;

export {CompoundCustomSelect as CustomSelect};
